import React, { useState, useContext } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaArrowRight, FaFingerprint } from "react-icons/fa";
import { AuthContext } from "../../context/AuthContext";
import "./LoginPage.css";

const LOCAL_API_BASE_URL = "http://localhost:5000";
const RENDER_API_BASE_URL = "https://wecareehs-backend.onrender.com";
const API_BASE_URL = process.env.REACT_APP_USE_RENDER === "true" ? RENDER_API_BASE_URL : LOCAL_API_BASE_URL;

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useContext(AuthContext);

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();

      if (!res.ok) {
        setMessage(`Error: ${data.error || "Invalid credentials"}`);
      } else {
        login(data.token, data.user);

        // Check if there's a return URL
        const from = location.state?.from || "/dashboard";
        navigate(from);
      }
    } catch (err) {
      console.error(err);
      setMessage("Server error. Try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="split-login-container">
      {/* Left Visual Panel */}
      <div className="visual-panel">
        <div className="visual-content">
          <h1 className="visual-heading">Future<br />Secured.</h1>
          <p className="visual-subtext">Access the next generation of Futuristic Safety.</p>
        </div>
        <div className="abstract-shape"></div>
        <div className="abstract-shape-2"></div>
      </div>

      {/* Right Form Panel */}
      <div className="form-panel">
        <div className="form-content">

          <div className="login-header">
            <h2>Hello Again.</h2>
            <p>Enter your credentials to access your account.</p>
          </div>

          <form onSubmit={handleLogin} className="split-form">
            <div className="minimal-input-group">
              <label>Email</label>
              <input
                type="email"
                className="minimal-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="name@example.com"
                required
              />
            </div>

            <div className="minimal-input-group">
              <div className="label-row">
                <label>Password</label>
                <Link to="/forgot-password" class="forgot-mini-link">Forgot?</Link>
              </div>
              <input
                type="password"
                className="minimal-input"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>

            {message && <div className="status-message">{message}</div>}

            <button type="submit" className="action-btn" disabled={loading}>
              {loading ? "Processing..." : "Sign In"} <FaArrowRight />
            </button>
          </form>

          <div className="panel-footer">
            <p>New here? <Link to="/register" className="highlight-link">Create Account</Link></p>
            <button
              className="admin-ghost-btn"
              onClick={() => navigate("/admin/login")}
            >
              <FaFingerprint size={14} /> Admin
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
